
import { includesValidator } from '../../common/utils/validator';

const Direction = {
  Top: 'top',
  Bottom: 'bottom',
};

export default {
  name: 'BbInfiniteScroll',
  props: {
    direction: {
      type: String,
      default: 'bottom',
      validator: includesValidator(Direction),
    },
    loadDataHandler: {
      type: Function,
    },
    height: {
      type: String,
      default: '300px',
    },
    maxHeight: {
      type: String,
      default: 'none',
    },
    identifier: {},
  },
};
